import { render, staticRenderFns } from "./rDireccion.vue?vue&type=template&id=07240660"
import script from "./rDireccion.vue?vue&type=script&lang=js"
export * from "./rDireccion.vue?vue&type=script&lang=js"
import style0 from "./rDireccion.vue?vue&type=style&index=0&id=07240660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports